module.exports = __webpack_public_path__ + "img/snow.cfc4d513.svg";